var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "500pt",
    height: "200.000000pt",
    viewBox: "0 0 500.000000 150.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(50.000000,664.000000) scale(0.100000,-0.100000)",
    fill: "#075e26",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2597 6473 c-14 -13 -6 -24 15 -21 27 4 36 28 11 28 -11 0 -23 -3 -26 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2670 6470 c0 -5 11 -10 24 -10 14 0 28 5 31 10 4 6 -7 10 -24 10 -17 0 -31 -4 -31 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2760 6470 c0 -5 11 -10 25 -10 14 0 25 5 25 10 0 6 -11 10 -25 10 -14 0 -25 -4 -25 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2840 6461 c0 -12 48 -27 57 -17 9 8 2 13 -30 21 -17 5 -27 3 -27 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2513 6453 c-7 -2 -13 -9 -13 -14 0 -14 24 -11 46 6 19 14 19 14 -1 14 -11 0 -26 -3 -32 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2443 6429 c-25 -9 -31 -29 -10 -29 19 0 52 26 41 32 -5 3 -19 2 -31 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2934 6425 c22 -17 46 -20 46 -6 0 10 -25 21 -48 21 -15 -1 -14 -3 2 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3000 6400 c0 -12 40 -33 48 -25 4 4 -2 13 -12 21 -23 16 -36 18 -36 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2360 6385 c-7 -9 -10 -18 -7 -21 7 -8 47 14 47 26 0 15 -26 12 -40 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3070 6351 c0 -12 42 -42 49 -36 5 6 -29 45 -41 45 -4 0 -8 -4 -8 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2291 6341 c-7 -5 -12 -14 -9 -21 2 -8 11 -5 28 9 17 14 20 20 10 21 -8 0 -21 -4 -29 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2225 6280 c-14 -16 -15 -20 -4 -20 16 0 39 19 39 32 0 14 -16 9 -35 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3130 6292 c0 -14 39 -46 47 -39 3 4 -2 16 -12 27 -19 21 -35 26 -35 12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2172 6228 c-7 -7 -12 -19 -12 -27 0 -11 4 -10 20 4 21 19 26 35 12 35 -4 0 -13 -5 -20 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3180 6223 c0 -5 6 -18 14 -29 17 -22 35 -11 20 13 -12 19 -34 29 -34 16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2116 6154 c-15 -40 4 -48 22 -9 9 20 9 25 -2 25 -8 0 -17 -7 -20 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3220 6142 c0 -19 12 -42 22 -42 14 0 5 43 -9 48 -7 2 -13 -1 -13 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2083 6089 c-7 -7 -13 -22 -13 -33 0 -19 1 -19 16 -4 9 8 14 23 12 32 -2 14 -5 15 -15 5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3240 6053 c0 -10 4 -25 10 -33 8 -12 10 -12 16 3 7 20 -1 47 -16 47 -5 0 -10 -8 -10 -17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4131 6039 c-17 -16 -45 -55 -63 -85 -26 -44 -37 -54 -53 -50 -11 3 -37 6 -58 6 -27 0 -40 5 -44 18 -13 36 -58 44 -68 13 -5 -17 -13 -19 -60 -14 -49 5 -57 3 -74 -18 -10 -13 -18 -27 -16 -30 3 -5 208 -82 252 -94 7 -2 -9 -36 -40 -83 -49 -75 -54 -80 -91 -83 -47 -5 -59 -26 -19 -35 41 -10 43 -12 31 -40 -9 -20 -9 -28 3 -40 14 -13 18 -12 42 6 l27 21 25 -28 c21 -23 26 -26 34 -13 7 10 5 24 -7 45 l-18 29 48 69 c26 38 49 74 51 81 3 6 50 -34 106 -89 96 -95 101 -98 116 -80 20 28 19 39 -10 85 -23 37 -24 42 -11 63 19 29 6 51 -26 45 -21 -4 -28 3 -55 53 l-30 58 44 67 c57 89 63 112 33 136 -29 24 -33 23 -69 -13z m54 -19 c3 -5 -5 -28 -17 -51 -13 -22 -31 -55 -40 -72 -10 -18 -18 -41 -18 -52 0 -29 58 -125 75 -125 14 0 31 -37 22 -47 -3 -3 3 -25 13 -49 11 -24 15 -44 10 -44 -6 0 -10 5 -10 10 0 6 -6 10 -14 10 -8 0 -27 15 -43 33 -16 17 -48 49 -71 70 -35 31 -46 36 -62 27 -20 -11 -87 -103 -111 -155 -8 -16 -17 -28 -20 -25 -3 3 -13 -1 -22 -8 -13 -11 -16 -9 -22 19 -6 26 -3 35 13 48 19 15 52 67 89 139 15 29 15 34 1 48 -8 9 -55 30 -103 47 -88 32 -120 57 -72 57 13 0 39 5 57 11 26 10 37 9 59 -4 15 -9 51 -19 79 -23 59 -7 76 2 117 66 44 67 76 93 90 70z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1101 6011 c-9 -6 -10 -11 -2 -15 14 -9 51 2 51 15 0 11 -30 12 -49 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2046 5994 c-4 -15 -4 -29 -1 -32 8 -8 25 19 25 41 0 26 -17 20 -24 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1180 6001 c0 -12 39 -25 48 -16 7 7 -17 25 -35 25 -7 0 -13 -4 -13 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1042 5978 c-7 -7 -12 -19 -12 -27 0 -11 4 -10 20 4 21 19 26 35 12 35 -4 0 -13 -5 -20 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3250 5965 c0 -8 0 -18 -1 -22 0 -4 4 -9 10 -11 6 -2 11 8 11 22 0 14 -4 26 -10 26 -5 0 -10 -7 -10 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1250 5964 c0 -17 28 -49 36 -41 4 4 -2 17 -14 30 -12 12 -22 17 -22 11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2030 5920 c0 -11 0 -23 -1 -27 0 -4 4 -9 10 -11 6 -2 11 10 11 27 0 17 -4 31 -10 31 -5 0 -10 -9 -10 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010 5890 c0 -16 5 -30 10 -30 6 0 10 14 10 30 0 17 -4 30 -10 30 -5 0 -10 -13 -10 -30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1300 5888 c0 -23 11 -48 21 -48 14 0 11 24 -6 46 -12 16 -14 17 -15 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3237 5893 c-11 -10 -8 -43 3 -43 6 0 10 4 10 9 0 5 3 16 6 25 6 16 -7 22 -19 9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2020 5826 c0 -14 5 -28 10 -31 6 -4 10 7 10 24 0 17 -4 31 -10 31 -5 0 -10 -11 -10 -24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1020 5822 c0 -15 28 -47 35 -40 8 8 -13 48 -25 48 -6 0 -10 -4 -10 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3201 5798 c-5 -13 -7 -25 -4 -28 5 -6 33 30 33 42 0 17 -21 7 -29 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1324 5794 c3 -9 6 -20 6 -25 0 -5 5 -9 10 -9 6 0 10 11 10 25 0 16 -6 25 -16 25 -11 0 -14 -5 -10 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2026 5762 c-7 -12 4 -52 15 -52 12 0 12 47 0 55 -5 3 -12 2 -15 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1066 5748 c16 -28 27 -38 36 -32 5 3 2 14 -8 25 -19 21 -39 26 -28 7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3162 5728 c-13 -13 -16 -38 -6 -38 8 0 33 32 34 43 0 11 -15 8 -28 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1335 5720 c-9 -14 4 -52 16 -45 12 8 12 42 0 50 -5 3 -12 1 -16 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1120 5688 c0 -18 20 -38 38 -38 19 0 10 20 -16 38 -19 12 -22 12 -22 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2040 5661 c0 -20 17 -37 27 -28 7 8 -7 47 -18 47 -5 0 -9 -9 -9 -19z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3100 5650 c-8 -16 -8 -20 4 -20 9 0 20 9 26 20 8 16 8 20 -4 20 -9 0 -20 -9 -26 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1180 5632 c0 -14 39 -46 47 -39 3 4 -2 16 -12 27 -19 21 -35 26 -35 12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1330 5615 c0 -14 5 -25 10 -25 6 0 10 11 10 25 0 14 -4 25 -10 25 -5 0 -10 -11 -10 -25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273 5605 c-40 -17 -73 -69 -73 -114 0 -40 30 -92 63 -110 13 -7 33 -31 45 -54 l20 -42 19 42 c10 23 28 47 41 52 33 16 62 70 62 117 0 49 -28 90 -76 110 -41 17 -60 17 -101 -1z m117 -63 c44 -55 7 -132 -65 -132 -87 0 -114 120 -34 154 40 17 75 10 99 -22z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284 5515 c-15 -23 -15 -27 0 -50 20 -30 56 -33 79 -7 21 23 22 46 1 66 -24 24 -61 20 -80 -9z m61 -24 c0 -8 -4 -16 -10 -18 -16 -5 -38 14 -30 26 9 16 40 9 40 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3040 5595 c-21 -25 -1 -31 23 -7 17 18 18 22 5 22 -8 0 -21 -7 -28 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2066 5592 c-2 -4 1 -18 8 -31 8 -15 16 -20 20 -13 4 7 2 21 -4 32 -12 22 -16 24 -24 12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1250 5572 c0 -11 37 -32 44 -25 8 9 -14 33 -30 33 -8 0 -14 -3 -14 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1316 5538 c-9 -34 -8 -35 24 -35 32 0 40 14 15 23 -8 4 -15 12 -15 20 0 22 -17 16 -24 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2974 5546 c-10 -8 -16 -17 -12 -21 8 -8 48 13 48 25 0 14 -13 12 -36 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2100 5508 c0 -19 18 -43 25 -36 9 9 -4 48 -16 48 -5 0 -9 -6 -9 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2900 5500 c-8 -5 -12 -12 -8 -15 9 -9 48 4 48 16 0 12 -21 11 -40 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1400 5486 c0 -13 20 -26 41 -26 18 0 8 17 -16 28 -20 9 -25 9 -25 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3792 5469 c-7 -12 -11 -23 -8 -26 8 -9 36 17 36 33 0 20 -13 17 -28 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1291 5461 c-6 -11 -11 -24 -11 -30 0 -20 17 -11 28 14 14 29 -2 44 -17 16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2833 5467 c-25 -11 -31 -27 -10 -27 19 0 40 16 36 28 -3 6 -12 6 -26 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1475 5450 c-7 -11 35 -31 49 -22 5 3 1 11 -9 19 -22 16 -32 16 -40 3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2140 5432 c0 -5 9 -17 20 -27 16 -14 20 -15 20 -4 0 16 -19 39 -32 39 -4 0 -8 -4 -8 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2748 5433 c-10 -2 -18 -9 -18 -14 0 -15 43 -7 48 9 4 12 0 13 -30 5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1554 5419 c-3 -5 5 -13 18 -18 24 -9 42 -5 33 8 -8 13 -44 20 -51 10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3740 5405 c-7 -9 -10 -18 -7 -22 8 -7 37 15 37 28 0 14 -16 11 -30 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2663 5403 c-7 -2 -13 -9 -13 -15 0 -14 43 -6 48 10 4 12 -12 15 -35 5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1250 5379 c-7 -11 -9 -24 -5 -27 7 -7 35 25 35 40 0 16 -19 8 -30 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1635 5391 c-6 -11 42 -27 52 -17 8 8 3 12 -24 20 -12 4 -24 2 -28 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1720 5365 c0 -8 7 -15 15 -15 8 0 17 0 20 0 14 0 4 15 -14 22 -15 5 -21 3 -21 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2190 5372 c0 -5 6 -17 14 -28 16 -21 30 -16 20 9 -6 16 -34 32 -34 19z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2575 5369 c-4 -6 -5 -12 -3 -14 7 -7 48 7 48 16 0 13 -37 11 -45 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2487 5354 c-4 -4 -4 -10 -2 -14 6 -10 55 0 55 11 0 10 -43 12 -53 3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3675 5340 c-14 -16 -15 -20 -4 -20 16 0 39 19 39 32 0 14 -16 9 -35 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1800 5341 c0 -10 47 -21 54 -13 3 3 3 9 0 13 -7 12 -54 12 -54 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2423 5343 c-31 -6 -29 -23 2 -23 16 0 25 6 25 15 0 8 -1 14 -2 14 -2 -1 -13 -4 -25 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1885 5330 c-3 -5 6 -12 20 -16 29 -7 41 -1 30 15 -8 14 -42 14 -50 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1200 5309 c-7 -11 -9 -24 -5 -27 7 -7 35 25 35 40 0 16 -19 8 -30 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1970 5320 c0 -5 14 -10 31 -10 17 0 28 4 24 10 -3 6 -17 10 -31 10 -13 0 -24 -4 -24 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2248 5323 c-23 -6 -23 -11 5 -34 30 -25 40 -24 32 4 -9 29 -16 34 -37 30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2315 5320 c-4 -6 7 -10 24 -10 17 0 31 5 31 10 0 6 -11 10 -24 10 -14 0 -28 -4 -31 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2055 5310 c3 -5 17 -10 31 -10 13 0 24 5 24 10 0 6 -14 10 -31 10 -17 0 -28 -4 -24 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2140 5310 c0 -5 14 -10 30 -10 17 0 30 5 30 10 0 6 -13 10 -30 10 -16 0 -30 -4 -30 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3616 5295 c-10 -8 -16 -19 -14 -25 2 -8 12 -5 27 8 28 21 16 37 -13 17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358 5248 c12 -12 24 -19 28 -15 10 10 -16 37 -34 37 -13 0 -12 -4 6 -22z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1140 5245 c-7 -9 -10 -18 -7 -22 8 -7 37 15 37 28 0 14 -16 11 -30 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3545 5246 c-10 -7 -16 -18 -14 -25 3 -9 11 -7 28 7 27 21 14 39 -14 18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2328 5228 c12 -12 24 -19 28 -15 10 10 -16 37 -34 37 -13 0 -12 -4 6 -22z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412 5208 c6 -17 36 -34 44 -25 4 4 -1 14 -12 22 -23 18 -37 19 -32 3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1074 5196 c-10 -8 -16 -17 -12 -21 8 -8 48 13 48 25 0 14 -13 12 -36 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2386 5203 c-8 -9 14 -33 30 -33 8 0 14 3 14 8 0 11 -37 32 -44 25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3467 5199 c-24 -14 -11 -32 14 -19 10 6 19 15 19 20 0 13 -10 12 -33 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480 5161 c0 -11 39 -25 47 -18 3 3 2 10 -2 16 -8 13 -45 15 -45 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1003 5157 c-25 -11 -31 -27 -10 -27 19 0 40 16 36 28 -3 6 -12 6 -26 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3380 5155 c-10 -12 -10 -15 3 -15 23 0 47 11 47 21 0 15 -37 10 -50 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2460 5151 c0 -12 39 -25 48 -16 7 7 -17 25 -35 25 -7 0 -13 -4 -13 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560 5131 c0 -12 39 -25 48 -16 7 7 -17 25 -35 25 -7 0 -13 -4 -13 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3304 5125 c-16 -12 -17 -14 -2 -15 23 0 48 11 48 21 0 14 -24 11 -46 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M907 5123 c-15 -14 -6 -24 16 -18 35 11 44 25 16 25 -14 0 -29 -3 -32 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2536 5121 c-7 -10 17 -21 42 -21 15 1 14 3 -2 15 -23 17 -33 19 -40 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645 5110 c-3 -5 6 -12 20 -16 29 -7 41 -1 30 15 -8 14 -42 14 -50 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M730 5100 c0 -5 14 -10 31 -10 17 0 28 4 24 10 -3 6 -17 10 -31 10 -13 0 -24 -4 -24 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M820 5100 c0 -5 11 -10 25 -10 14 0 25 5 25 10 0 6 -11 10 -25 10 -14 0 -25 -4 -25 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3217 5103 c-24 -23 9 -31 39 -8 18 14 18 14 -7 15 -14 0 -29 -3 -32 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2620 5091 c0 -11 39 -25 47 -18 3 3 2 10 -2 16 -8 13 -45 15 -45 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3135 5079 c-4 -6 -5 -12 -3 -14 7 -7 48 7 48 16 0 13 -37 11 -45 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2700 5070 c0 -5 14 -10 31 -10 17 0 28 4 24 10 -3 6 -17 10 -31 10 -13 0 -24 -4 -24 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3063 5072 c-13 -2 -23 -8 -23 -13 0 -12 47 -12 55 0 7 13 -5 18 -32 13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2785 5060 c-3 -5 3 -10 14 -10 12 0 24 0 28 -1 4 0 9 4 11 10 5 14 -45 15 -53 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2877 5063 c-14 -13 -6 -23 17 -23 30 0 42 15 20 24 -20 8 -29 8 -37 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2967 5063 c-14 -13 -6 -24 15 -21 27 4 36 28 11 28 -11 0 -23 -3 -26 -7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/background.96e014daaf90d0c1fbaa406024aa6665.svg";
export { ForwardRef as ReactComponent };